import { useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import "./FXTable.scss";

type PropsData = {
  onTimeChange?: (start: string, end: string) => void;
};

const TimeRangePicker = ({ onTimeChange }: PropsData) => {
  const [startTime, setStartTime] = useState<Date | null>(null);
  const [endTime, setEndTime] = useState<Date | null>(null);

  const handleTimeChange = (time: Date | null, type: 'START' | 'END') => {
    if (!time) return;

    if (type === 'START') {
      setStartTime(time);
    } else {
      setEndTime(time);
    }

    if (type === 'END' && startTime && time) {
      const formattedStart = moment(startTime).format('HH:mm');
      const formattedEnd = moment(time).format('HH:mm');
      onTimeChange && onTimeChange(formattedStart, formattedEnd);
    }
  };

  return (
    <div className="d-flex">
      <DatePicker
        selected={startTime}
        className="form-control form-control-sm calenderWidth"
        onChange={(time) => handleTimeChange(time, 'START')}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={15}
        dateFormat="h:mm aa"
        placeholderText="Start Time"
      />
      <DatePicker
        selected={endTime}
        className="form-control form-control-sm calenderWidth ms-2"
        onChange={(time) => handleTimeChange(time, 'END')}
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={15}
        dateFormat="h:mm aa"
        minTime={startTime || new Date(0, 0, 0, 0, 0)}
        maxTime={new Date(0, 0, 0, 23, 45)}
        placeholderText="End Time"
      />
    </div>
  );
};

export default TimeRangePicker;
